<template>
  <div class="steps-section" id="stepsSection">
    <StepCard
      v-for="(step, index) in steps"
      :key="index"
      :stepNumber="step.number"
      :title="step.title"
      :content="step.content"
    />
  </div>
</template>

<script>
import StepCard from "./ReusableComponents/StepCard.vue";

export default {
  name: "StepsSection",
  components: {
    StepCard,
  },
  data() {
    return {
      steps: [
        {
          number: 1,
          title: "Optimizing Inventory Management",
          content:
            "By offering brands a platform to convert unsold inventory into revenue-generating opportunities, Wecobi helps businesses grow without increasing production. This reduces waste and avoids the environmental costs associated with traditional inventory disposal methods.",
        },
        {
          number: 2,
          title: "Sustainable Consumer Engagement",
          content:
            "Wecobi’s platform encourages a collaborative consumption model, where consumers are part of a pre-order and co-buying community. This approach reduces the need for overproduction, aligning consumer demand with supply and preventing excess inventory.",
        },
        {
          number: 3,
          title: "Data-Driven Decision Making",
          content:
            "Leveraging advanced analytics, Wecobi enables brands to optimize their production, marketing, and sales strategies based on real-time consumer insights. This precision reduces the likelihood of overproduction and ensures that growth is sustainable.",
        },
        {
          number: 4,
          title: "Promoting a Circular Economy",
          content:
            "Wecobi's focus on extending the lifecycle of products through innovative strategies supports a circular economy. By keeping products in circulation longer, we help brands reduce waste and environmental impact while opening up new avenues for growth. This approach not only aligns with sustainability goals but also ensures that growth remains both profitable and ecologically responsible.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.steps-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  padding: 80px 90px;
  background-color: #f5f5f5;
  box-sizing: border-box;
  border-radius: 20px;
}

.stepCard-body {
  border: none;
  border-right: 2px solid #e6e6f3;
  border-bottom: 2px solid #e6e6f3;
}

.stepCard-body:nth-child(2n) {
  border-right: none;
}

.steps-section .stepCard-body:last-child,
.steps-section .stepCard-body:nth-last-child(2) {
  border-bottom: none;
}

@media (max-width: 1280px) {
  .steps-section {
    padding: 80px 76px;
  }
}

@media (max-width: 744px) {
  .steps-section {
    padding: 50px 60px;
  }
}

@media (max-width: 588px) {
  .steps-section {
    padding: 20px 50px;
    grid-template-columns: 1fr;
  }
  .stepCard-body {
    border: none;
    border-bottom: 2px solid #e6e6f3;
  }

  .stepCard-body:not(:last-child) {
    border-bottom: 2px solid #e6e6f3;
  }

  .stepCard-body:last-child {
    border-bottom: none;
  }
  .steps-section .stepCard-body:nth-last-child(2) {
    border-bottom: 2px solid #e6e6f3;
  }
}

@media (max-width: 431px) {
  .steps-section {
    padding: 20px 30px;
  }
}
</style>
